import * as service from "../service";
import { store } from "../../store";

export type EditProfileParams = {
  username: string;
  phone_num: string;
  /** Already-uploaded profile icon URL; uploading is the caller's job. */
  profile_icon?: string;
};

/**
 * Update the profile of the currently logged-in student.
 * Backend: PUT /api/user/editAccount/editProfile
 */
export const EditProfileAPI = async ({
  username,
  phone_num,
  profile_icon,
}: EditProfileParams) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call("PUT", "api/user/editAccount/editProfile", {
      id: user?.id,
      profile_icon,
      username,
      phone_num,
    });
    return resp;
  } catch (err) {
    console.error(`EditProfileAPI ${err}`);
    return { status: -1, resp: err };
  }
};

/** Request an SMS OTP for a new profile phone number (authenticated). */
export const sendProfilePhoneVerificationCodeAPI = async (
  phone: string,
  regionCode: string,
) => {
  if (!phone || !phone.trim()) {
    return { result: "Phone number is required", status: 2 };
  }
  try {
    return await service.call(
      "POST",
      "api/user/editAccount/sendPhoneVerificationCode",
      { phone, regionCode },
      { timeout: 20000 },
    );
  } catch (err) {
    console.error(`sendProfilePhoneVerificationCodeAPI ${err}`);
    return { status: -1, resp: err };
  }
};

/** Verify the SMS OTP for a new profile phone number (authenticated). */
export const verifyProfilePhoneCodeAPI = async (
  phone: string,
  regionCode: string,
  code: string,
) => {
  if (!phone || !phone.trim() || !code || !code.trim()) {
    return {
      result: "Phone number and verification code are required",
      status: 2,
    };
  }
  try {
    return await service.call(
      "POST",
      "api/user/editAccount/verifyPhoneCode",
      { phone, regionCode, code },
      { timeout: 20000 },
    );
  } catch (err) {
    console.error(`verifyProfilePhoneCodeAPI ${err}`);
    return { status: -1, resp: err };
  }
};
